import React, { useEffect, useState } from 'react';
import { Card, Col, Empty, Row, Image, Button } from 'antd';
import totalInvoice from "../assets/images/dashboard/total_invoice.svg";
import dispute_invoice from "../assets/images/dashboard/dispute_invoice.svg";
import send_Sap from "../assets/images/dashboard/send_Sap.svg";
import success_invoice from "../assets/images/dashboard/success_invoice.svg";
import axios from '../util/axiosConfig';
import '../styles/dashboard.css';
import Modals from '../components/Shared/Modal';

const LandingPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [cardData, setcardData] = useState<any>({});
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [selectedFilterOptions, setSelectedFilterOptions] = useState<any>({});
  const [isliveMode, setIsLivemode] = useState(false);

  useEffect(() => {
    if(process.env.REACT_APP_API_URL === 'https://brigade-api.digiaim.ai/'){
      setIsLivemode(true)
    }else{
      setIsLivemode(false)
    }
    getDashboardData()
  }, [selectedFilterOptions])
  const getDashboardData = async() =>{
    setLoading(true);
    try {
      console.log(selectedFilterOptions, 'selectedFilterOptions');
      
      let body = selectedFilterOptions ? selectedFilterOptions : {}
      const response = await axios.post('/dashboard/get-dashboard-overview', body, {});      
      if (response.data?.error === null) {
        setcardData(response.data.data)
      } else {
        console.error(response.data?.error);
      }
    } catch (error) {
      console.error('Failed to fetch dashboard data');
    } finally {
      setLoading(false);
    }
  }
  const openFilterModal = () => {
    setIsFilterModalOpen(true);
  };
  const closeFilterModal = (data: any) => {
   setSelectedFilterOptions(data);
    setIsFilterModalOpen(false);
    // getDashboardData()
  };
  return (
    <>
    <Row>
      <Col span={12}>
      <div className='pageHead'>Overview</div>
      </Col>
      <Col span={12} className='dashboard_Filter'>
      <Button type='default' onClick={openFilterModal}>Filter</Button>
      </Col>
    </Row>
      <Row>
        <Col span={!isliveMode ? 4 : 6} className='dashboardCard_outer'>
          <Card className={!isliveMode ? 'dashboard_cards' : 'livedashboardCards'}>
            <div className='cardImage'>
              <Image preview={false} src={totalInvoice} />
            </div>
            <div className='cardDetails'>
              <p className='cardValue'>{cardData.totalInvoices}</p>
              <p className='cardName'>Total Invoices</p>
            </div>
          </Card>
        </Col>
        <Col span={!isliveMode ? 4 : 6} className='dashboardCard_outer'>
          <Card className={!isliveMode ? 'dashboard_cards' : 'livedashboardCards'}>
            <div className='cardImage'>
              <Image preview={false} src={success_invoice} />
            </div>
            <div className='cardDetails'>
              <p className='cardValue'>{cardData.successInvoices}</p>
              <p className='cardName'>Success Invoices</p>
              <p className='cardPercent'>{cardData.successInvoicesPercentage} %</p>
            </div>
          </Card>
        </Col>
        {
          !isliveMode && (
<Col span={4} className='dashboardCard_outer'>
          <Card className='dashboard_cards'>
            <div className='cardImage'>
              <Image preview={false} src={send_Sap} />
            </div>
            <div className='cardDetails'>
              <p className='cardValue'>{cardData.sendToSapInvoices}</p>
              <p className='cardName'>Send to SAP</p>
              <p className='cardPercent'>{cardData.sendToSapInvoicesPercentage} %</p>
            </div>
          </Card>
        </Col>
          )
        }
        
        <Col span={11}>
          <Card className='detailed_card'>
            <Row>
              <Col span={8}>
              <div className='detailedCardSection'>
                <div className='cardImage'>
                  <Image preview={false} src={dispute_invoice} />
                </div>
                <div className='cardDetails'>
                  <p className='cardValue'>{cardData.disputeInvoices}</p>
                  <p className='cardName'>Dispute Invoices</p>
                </div>
              </div>
              </Col>
              <Col span={16}>
                <div className='detailedCard_inner'>
                  <div className='innerTitle'>Details of Dispute Invoices</div>
                  <Row className='detailedTwoOuter'>
                    <Col span={8} className='detailedTwoSections'>
                      <div className='detailPoints'>{cardData.creditNote}</div>
                      <div className='detailedNames'>Credit Note</div>
                      <div className='detailedPercentage'>{cardData.creditNotePercentage} %</div>
                    </Col>
                    <Col span={8} className='detailedTwoSections'>
                      <div className='detailPoints'>{cardData.debitNote}</div>
                      <div className='detailedNames'>Debit Note</div>
                      <div className='detailedPercentage'>{cardData.debitNotePercentage} %</div>
                    </Col>
                    <Col span={8} className='detailedThreeSections'>
                      <div className='detailPoints'>{cardData.creditMemo}</div>
                      <div className='detailedNames'>Credit Memo</div>
                      <div className='detailedPercentage'>{cardData.creditMemoPercentage} %</div>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={8} className='detailedThreeSections'>
                      <div className='detailPoints'>{cardData.acceptance}</div>
                      <div className='detailedNames'>Acceptance</div>
                      <div className='detailedPercentage'>{cardData.acceptancePercentage} %</div>
                    </Col>
                    <Col span={8} className='detailedThreeSections'>
                      <div className='detailPoints'>{cardData.adjustment}</div>
                      <div className='detailedNames'>Adjustment</div>
                      <div className='detailedPercentage'>{cardData.adjustmentPercentage} %</div>
                    </Col>
                    <Col span={8} className='detailedThreeSections'>
                      <div className='detailPoints'>{cardData.rejection}</div>
                      <div className='detailedNames'>Rejection</div>
                      <div className='detailedPercentage'>{cardData.rejectionPercentage} %</div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <Modals isOpen={isFilterModalOpen} onClose={closeFilterModal} pdfUrl={null} from={'dashboard'} />
    </>
  );
}

export default LandingPage;
